<template>
    <v-container fluid>
        <sale-form
            :model="model"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.add')"
        >
        </sale-form>
    </v-container>
</template>

<script>
import ProductSale from '@/models/product/ProductSale'
import SaleForm from './Form'

export default {
    components: {
        SaleForm,
    },

    data: () => {
        return {
            sale: new ProductSale(),
        }
    },

    computed: {
        model() {
            let model = this.sale
            return model
        },
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
